export const TOUCH_TYPE = {
  CLICK: 'CLICK',
  IMPRESSION: 'IMPRESSION',
} as const;
